import { render, staticRenderFns } from "./IconSettingManage.vue?vue&type=template&id=d9622a4c&"
import script from "./IconSettingManage.vue?vue&type=script&lang=js&"
export * from "./IconSettingManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports